import { createTheme } from '@mui/material/styles';
import { UserTheme } from '../lib/utils';
import { COLOR_VARIABLES } from './colors';
//import type {} from '@mui/x-data-grid/themeAugmentation';
import type {} from '@mui/x-date-pickers/themeAugmentation';

export const getTheme = (userTheme: UserTheme) => {
    document.documentElement.style.setProperty('--inputGroupText', userTheme.stateOpen);
    document.documentElement.style.setProperty('--color-white', userTheme.colorWhite);

    document.documentElement.style.setProperty('--color-lightGray', userTheme.colorLightGray);

    document.documentElement.style.setProperty('--color-blue', userTheme.colorBlue || '');
    document.documentElement.style.setProperty('--color-lightBlue', userTheme.colorLightBlue || '');
    document.documentElement.style.setProperty('--color-midGray', userTheme.colorMidGray || '');
    document.documentElement.style.setProperty('--color-darkGray', userTheme.colorDarkGray || '');

    document.documentElement.style.setProperty('--color-green', userTheme.colorGreen || '');
    document.documentElement.style.setProperty(
        '--color-lightGreen',
        userTheme.colorLightGreen || ''
    );    

    document.documentElement.style.setProperty('--color-brown', userTheme.colorBrown || '');

    document.documentElement.style.setProperty('--color-red', userTheme.colorRed || '');
    document.documentElement.style.setProperty('--color-yellow', userTheme.colorYellow || '');

    document.documentElement.style.setProperty('--stateOpen', userTheme.stateOpen);
    document.documentElement.style.setProperty('--stateAssigned', userTheme.stateAssigned);
    document.documentElement.style.setProperty('--stateResourced', userTheme.stateResourced);
    document.documentElement.style.setProperty('--stateOngoing', userTheme.stateOngoing);
    document.documentElement.style.setProperty('--stateDone', userTheme.stateDone);
    document.documentElement.style.setProperty('--statePaused', userTheme.statePaused);
    document.documentElement.style.setProperty('--stateCancelled', userTheme.stateCancelled);
    document.documentElement.style.setProperty('--stateFailed', userTheme.stateFailed);

    document.documentElement.style.setProperty('--primaryColor', userTheme.primary);
    document.documentElement.style.setProperty('--primaryColorDark', userTheme.primaryDark);
    document.documentElement.style.setProperty('--primaryColorLight', userTheme.primaryLight);
    document.documentElement.style.setProperty('--primaryTextColor', userTheme.primaryText);

    document.documentElement.style.setProperty('--secondaryColor', userTheme.secondary);
    document.documentElement.style.setProperty('--secondaryColorDark', userTheme.secondaryDark);
    document.documentElement.style.setProperty('--secondaryColorLight', userTheme.secondaryLight);
    document.documentElement.style.setProperty('--secondaryTextColor', userTheme.secondaryText);

    document.documentElement.style.setProperty('--disabledColor', userTheme.disabled);
    document.documentElement.style.setProperty('--disabledBgColor', userTheme.disabledBgColor);
    document.documentElement.style.setProperty('--dashboardBgColor', userTheme.dashboardBgColor);

    document.documentElement.style.setProperty('--successColor', userTheme.successColor);
    document.documentElement.style.setProperty('--warningColor', userTheme.warningColor);
    document.documentElement.style.setProperty('--errorColor', userTheme.errorColor);

    document.documentElement.style.setProperty('--backgroundolor', userTheme.background);

    return createTheme({
        typography: {
            fontFamily: 'IBM Plex Sans',
            fontWeightLight: 300,
            fontWeightRegular: 400,
            fontWeightMedium: 500,
            fontWeightBold: 800
        },
        palette: {
            primary: {
                main: userTheme.primary,
                contrastText: userTheme.primaryText
            },
            secondary: {
                main: userTheme.secondary,
                contrastText: userTheme.secondaryText
            },
            background: {
                default: userTheme.background
            },
            success: {
                main: userTheme.successColor
            },
            warning: {
                main: userTheme.warningColor
            },
            disabled: {
                main: userTheme.disabled
            }
        },
        components: {
            MuiToggleButton: {
                styleOverrides: {
                    root: {
                        color: userTheme.primary,
                        '&.MuiToggleButtonGroup-grouped:not(:last-of-type)': {
                            borderRadius: '8px'
                        },
                        '&.MuiToggleButtonGroup-grouped:not(:first-of-type)': {
                            borderRadius: '8px'
                        },
                        '&.Mui-selected': {
                            backgroundColor: 'transparent',
                            borderRadius: '8px',
                            color: userTheme.primaryText,
                            border: `2px solid var(--primaryColor) !important`
                        }
                    }
                }
            },
            MuiFormHelperText: {
                styleOverrides: {
                    root: {
                        fontWeight: 500,
                        fontSize: '15px',
                        lineHeight: '19.5px'
                    }
                }
            },
            MuiPickersInputBase: {
                styleOverrides: {
                    root: {
                        backgroundColor: userTheme.background,
                        borderColor: userTheme.primary,
                        borderRadius: '8px!important',
                        '&.Mui-disabled': {
                            color: userTheme.primaryText,
                            WebkitTextFillColor: userTheme.primaryText
                        },
                        '& .MuiPickersOutlinedInput-root': {
                            borderRadius: '8px!important',
                            color: userTheme.primaryText
                            /* '&.Mui-disabled': {
                                color: userTheme.primaryText,
                                WebkitTextFillColor: userTheme.primaryText,
                                ' .MuiOutlinedInput-input': {
                                    //'-webkit-text-fill-color': userTheme.disabled
                                    //'-webkit-text-fill-color': userTheme.primaryText
                                    WebkitTextFillColor: userTheme.primaryText
                                }
                            }*/
                        },
                        '& .MuiInput-underline:after': {
                            borderColor: userTheme.primary,
                            color: userTheme.primaryText //userTheme.primary
                        },
                        '& legend': { display: 'none' },
                        '& fieldset': { top: 0 },
                        '& div': {
                            borderColor: userTheme.primary
                        },
                        '&.Mui-focused fieldset': {
                            color: userTheme.primaryText //userTheme.primary
                        }
                    },
                    input: {
                        borderRadius: '8px!important',
                        '&.Mui-disabled': {
                            color: `${userTheme.primary}!important`
                        }
                    }
                }
            },
            MuiPickersInput: {
                styleOverrides: {
                    root: {
                        backgroundColor: userTheme.background,
                        borderRadius: '8px!important',
                        '& .MuiOutlinedInput-root': {
                            borderRadius: '8px!important'
                        }
                    }
                }
            },
            MuiInput: {
                styleOverrides: {
                    root: {
                        borderRadius: '8px!important',
                        '& .MuiOutlinedInput': {
                            borderRadius: '8px!important',
                            '& .MuiSelect': {
                                borderRadius: '8px!important'
                            }
                        }
                    }
                }
            },
            MuiInputBase: {
                styleOverrides: {
                    root: {
                        borderRadius: '8px!important',
                        '& .MuiOutlinedInput': {
                            borderRadius: '8px!important',
                            '& .MuiSelect': {
                                borderRadius: '8px!important'
                            }
                        }
                    },
                    input: {
                        borderRadius: '8px!important',
                        '&.Mui-disabled': {
                            color: `${userTheme.primary}!important`
                        }
                    }
                }
            },
            MuiAlert: {
                styleOverrides: {
                    root: {
                        borderRadius: '8px'
                    },
                    standardInfo: {
                        //backgroundColor: 'black',
                        //color: '#fff'
                    },
                    filledInfo: {
                        //backgroundColor: 'black',
                        //color: '#fff'
                    },
                    outlinedInfo: {
                        //backgroundColor: 'black',
                        //color: '#fff',
                        //border: '1px solid #fff'
                    },
                }
            },
            /*MuiSvgIcon: {
                styleOverrides: {
                    root: {
                        fill: `${userTheme.primary}`,
                        color: `${userTheme.primary}`,
                        '&.Mui-disabled': {
                            //fill: `${userTheme.disabled} !important`
                            fill: `${userTheme.primary} !important`
                        }
                    }
                }
            },*/
            MuiPaper: {
                styleOverrides: {
                    root: {
                        '&.MuiDialog-paper': {
                            maxWidth: 'unset'
                        }
                    }
                }
            },
            MuiPopover: {
                styleOverrides: {
                    root: {
                        zIndex: 10000
                    }
                }
            },
            MuiFormControl: {
                styleOverrides: {
                    root: {
                        marginTop: '25px',
                        borderRadius: '8px',
                        '& .MuiInputBase': {
                            '& .MuiOutlinedInput': {
                                '& .Mui-Select': {
                                    root: {
                                        borderRadius: '8px'
                                    }
                                }
                            }
                        },

                        '& .MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root': {
                            borderRadius: '8px'
                        },

                        '&.Project-Share-Input': {
                            width: '98%',
                            marginBottom: '20px',
                            marginTop: '20px !important',
                            marginLeft: '10px',

                            '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                    color: userTheme.primary,
                                    borderColor: `${userTheme.primary} !important`
                                }
                            }
                        },
                        '& .css-1pakpsi-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root': {
                            backgroundColor: userTheme.background
                        },
                        '&.RoleControlSelector': {
                            '& .css-10hhxyn-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.MuiSelect-select':
                                {
                                    backgroundColor: userTheme.background
                                }
                        },

                        '&.Seletor-Style': {
                            textAlign: 'left',

                            //selector text green
                            '& .css-10hhxyn-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.MuiSelect-select':
                                {
                                    color: userTheme.successColor
                                },
                            '& .css-10dfbeb-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-10dfbeb-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-10dfbeb-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input':
                                {
                                    color: userTheme.successColor
                                },
                            //green outline
                            '& .css-1ac2hp4-MuiOutlinedInput-notchedOutline': {
                                borderColor: `${userTheme.successColor} !important`
                            },
                            //green label
                            '& .css-1gc78e3-MuiFormLabel-root-MuiInputLabel-root': {
                                color: `${userTheme.successColor} !important`
                            },
                            //arrow down green
                            '& .css-169z5f9-MuiSvgIcon-root-MuiSelect-icon': {
                                color: `${userTheme.successColor}`
                            }
                        }
                    }
                }
            },
            MuiFormLabel: {
                styleOverrides: {
                    root: {
                        '&.Mui-disabled': {
                            //color: `${userTheme.disabled} !important`,
                            '& .MuiSvgIcon-root': {
                                // fill: `${userTheme.disabled} !important`
                                fill: `${userTheme.primary} !important`
                            }
                        }
                    }
                }
            },
            MuiIconButton: {
                styleOverrides: {
                    root: {
                        //marginRight: '14px',
                        '&.Mui-disabled': {
                            //color: `${userTheme.disabled} !important`,
                            color: `${userTheme.primary} !important`,
                            '& .MuiSvgIcon-root': {
                                //fill: `${userTheme.disabled} !important`
                                fill: `${userTheme.disabled} !important`
                            },
                            '& .MuiOutlinedInput': {
                                color: `${userTheme.disabled} !important`
                            }
                        }
                    }
                }
            },
            MuiTextField: {
                styleOverrides: {
                    root: {
                        borderRadius: '8px',
                        '& legend': { display: 'none' },
                        '& fieldset': { top: 0 },
                        '& div': {
                            borderColor: userTheme.primary
                        },
                        '& .MuiInput-underline:after': {
                            borderColor: userTheme.primary,
                            color: userTheme.primaryText //userTheme.primary
                        },
                        '& .MuiOutlinedInput-root': {
                            borderRadius: '8px',
                            '&:hover fieldset': {
                                //borderColor: `${userTheme.primary}`
                            },
                            '& fieldset': {
                                color: userTheme.primary //userTheme.primary
                            },
                            '&.Mui-focused fieldset': {
                                color: userTheme.primaryText //userTheme.primary
                            }
                        }
                    }
                }
            },
            MuiSelect: {
                styleOverrides: {
                    icon: {
                        color: `${userTheme.primary} !important`,
                        '& .Mui-disabled': {
                            // color: `${userTheme.disabled} !important`
                        }
                    },
                    outlined: {
                        borderRadius: '8px'
                    },
                    select: {
                        borderColor: userTheme.primary,
                        color: userTheme.primaryText,
                        fill: userTheme.primary,

                        outlined: {
                            backgroundColor: userTheme.primary,
                            borderRadius: '8px!important'
                        },
                        filled: {
                            backgroundColor: userTheme.primary
                        },
                        standard: {
                            backgroundColor: userTheme.primary
                        }
                    }
                }
            },
            MuiMenuItem: {
                styleOverrides: {
                    root: {
                        color: userTheme.primary
                    }
                }
            },
            MuiInputLabel: {
                styleOverrides: {
                    root: {
                        // label text styles:
                        fontFamily: 'IBM Plex Sans',
                        fontStyle: 'normal',
                        fontWeight: 500,
                        fontSize: '15px',
                        lineHeight: '20px',
                        alignItems: 'flex-end',
                        letterSpacing: '1.4625px',
                        textTransform: 'uppercase',
                        color: userTheme.primary, //userTheme.primaryText, //,
                        '&.Mui-disabled': {
                            //color: userTheme.disabled,
                            color: userTheme.primaryText, //userTheme.primary,
                            fontFamily: 'IBM Plex Sans',
                            fontStyle: 'normal',
                            fontWeight: 500,
                            fontSize: '15px',
                            lineHeight: '20px',
                            alignItems: 'flex-end',
                            letterSpacing: '1.4625px',
                            textTransform: 'uppercase'
                        },
                        '&.Mui-focused': {
                            color: userTheme.primaryText, //userTheme.primary,
                            fontFamily: 'IBM Plex Sans',
                            fontStyle: 'normal',
                            fontWeight: 500,
                            fontSize: '15px',
                            lineHeight: '20px',
                            alignItems: 'flex-end',
                            letterSpacing: '1.4625px',
                            textTransform: 'uppercase'
                        },
                        '&.Mui-error': {
                            color: userTheme.primary,
                            fontFamily: 'IBM Plex Sans',
                            fontStyle: 'normal',
                            fontWeight: 500,
                            fontSize: '15px',
                            lineHeight: '20px',
                            alignItems: 'flex-end',
                            letterSpacing: '1.4625px',
                            textTransform: 'uppercase'
                        }
                    },
                    shrink: {
                        '&.Mui-disabled': {
                            transform: 'translate(5px, -20px) scale(0.75)',
                            //color: userTheme.disabled,
                            fontFamily: 'IBM Plex Sans',
                            fontStyle: 'normal',
                            fontWeight: 500,
                            fontSize: '15px',
                            lineHeight: '20px',
                            alignItems: 'flex-end',
                            letterSpacing: '1.4625px',
                            textTransform: 'uppercase'
                        },
                        transform: 'translate(5px, -20px) scale(0.75)',
                        color: userTheme.primaryText, //`${userTheme.primary}`,
                        fontFamily: 'IBM Plex Sans',
                        fontStyle: 'normal',
                        fontWeight: 500,
                        fontSize: '15px',
                        lineHeight: '20px',
                        alignItems: 'flex-end',
                        letterSpacing: '1.4625px',
                        textTransform: 'uppercase'
                    }
                }
            },
            MuiFormControlLabel: {
                styleOverrides: {
                    root: {
                        color: userTheme.primaryText
                    }
                }
            },
            MuiOutlinedInput: {
                styleOverrides: {
                    root: {
                        backgroundColor: userTheme.background,
                        padding: '0 !important',
                        color: `${userTheme.primaryText}`,
                        borderRadius: '8px!imporatant',
                        '& legend': { width: 0 },
                        '& .MuiSelect': {
                            borderRadius: '8px!imporatant'
                        },
                        '& input': {
                            borderRadius: '8px!imporatant',
                            color: `${userTheme.primaryText}`
                        },

                        '&:hover fieldset': {
                            //borderColor: `${userTheme.primary}`
                        },

                        '& .notchedOutline': {
                            borderColor: `${userTheme.primary}`,
                            legend: {
                                width: '0% !important'
                            }
                        },
                        '&.Mui-disabled': {
                            color: `${userTheme.primary}`, //`${userTheme.disabled} !important`,
                            // backgroundColor: `${userTheme.disabledBgColor} !important`,
                            ' .MuiOutlinedInput-notchedOutline': {
                                //borderColor: `${userTheme.background} !important`
                                borderColor: '#D9DFE3'
                            },
                            ' .MuiOutlinedInput-input': {
                                //'-webkit-text-fill-color': userTheme.disabled
                                //'-webkit-text-fill-color': userTheme.primaryText
                                WebkitTextFillColor: userTheme.primaryText
                            }
                        },
                        '&.Mui-focused': {
                            ' .MuiOutlinedInput-notchedOutline': {
                                borderColor: `${userTheme.primary}`
                            }
                        },
                        '&.Mui-error': {
                            ' .MuiOutlinedInput-notchedOutline': {
                                borderColor: `${userTheme.errorColor}`
                            }
                        }
                    },
                    notchedOutline: {
                        borderColor: `${userTheme.primary}`,
                        '& .css-1in441m': {
                            width: '0% !important'
                        }
                    },
                    input: {
                        padding: '15px',
                        '&.Mui-disabled': {
                            opacity: 1
                            //backgroundColor: userTheme.disabledBgColor
                        },
                        ':focus': {
                            boxShadow: '0 3px 10px rgba(0,0,0, 0.2)'
                        }
                    }
                }
            },
            MuiAccordion: {
                styleOverrides: {
                    root: {
                        '&::before': {
                            display: 'none' // Hides a border on top of the accordion item
                        },
                        '&.Mui-expanded': { margin: '0' }
                    }
                }
            },
            MuiTableCell: {
                styleOverrides: {
                    root: {
                        borderBottom: `1px solid ${userTheme.primary}`
                    }
                }
            },
            MuiDivider: {
                styleOverrides: {
                    root: {
                        borderColor: `${userTheme.primary}`
                    }
                }
            },
            MuiTooltip: {
                styleOverrides: {
                    popper: {
                        zIndex: '10000'
                    }
                }
            },
            MuiRating: {
                styleOverrides: {
                    root: {
                        alignItems: 'center',
                        display: 'flex',
                        '& .MuiRating-iconFilled': {
                            '& .LOW': {
                                width: '15px',
                                height: '15px',
                                fill: COLOR_VARIABLES.colors_red
                            },
                            '& .MEDIUM': {
                                width: '15px',
                                height: '15px',
                                fill: COLOR_VARIABLES.colors_black
                            },
                            '& .HIGH': {
                                width: '15px',
                                height: '15px',
                                fill: COLOR_VARIABLES.colors_green
                            },
                            '& .URGENT': {
                                width: '15px',
                                height: '15px',
                                fill: COLOR_VARIABLES.colors_green
                            }
                        },
                        '& .MuiRating-iconEmpty': {
                            '& .LOW': {
                                width: '15px',
                                height: '15px',
                                fill: COLOR_VARIABLES.colors_red
                            },
                            '& .MEDIUM': {
                                width: '15px',
                                height: '15px',
                                fill: COLOR_VARIABLES.colors_black
                            },
                            '& .HIGH': {
                                width: '15px',
                                height: '15px',
                                fill: COLOR_VARIABLES.colors_green
                            },
                            '& .URGENT': {
                                width: '15px',
                                height: '15px',
                                fill: COLOR_VARIABLES.colors_green
                            }
                        }
                    }
                }
            }
        }
    });
};
